var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-infobox.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/fonts/fonts.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
var XInfobox = class extends ChemistryLitElement {
  render() {
    return html`
      <x-flex
        padding="md"
        space="sm"
        ${css({ background: this.colors.neutral.shade(50), borderRadius: this.sizes.borderRadius })}
      >
        <x-h3> Info </x-h3>
        <x-text>
          <slot></slot>
        </x-text>
      </x-flex>
    `;
  }
};
XInfobox = __decorateClass([
  customElement("x-infobox")
], XInfobox);
export {
  XInfobox
};
